import { Flex, InputNumber, Modal, Form, Checkbox } from "antd"
import { UserOutlined } from '@ant-design/icons'
import { fetchSensorConfig, saveSensorConfig } from "../../../api/Cards"
import { useState, useCallback, useEffect, useMemo, useRef } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useTranslation } from "react-i18next"

export const SensorModal = ({ Card, sensorId, onClose }) => {
    const handleClose = () => onClose()
    const navigate = useNavigate()
    const handleSaveConfig = () => {
        writeData();
        handleClose()
    }
    const handleCancel = () => handleClose()
    const { t } = useTranslation()
    const [sensorConfig, setSensorConfig] = useState({MaxThreshold: 0, MinThreshold: 0, bActive: false})
    const writeSensorConfig = useRef({ MaxThreshold: 0, MinThreshold: 0, bActive: false })
    async function fetchData() {
        //console.log({ Token: getToken(), CardID: id, CardIndex: 0 })
        const data = await fetchSensorConfig({ MetaData: Card, SensorId: sensorId });
        if (typeof data === "number") {
            console.log("Disconnect: ", data)
            navigate('/dashboard');
        }

        console.log("res: ", data)
        setSensorConfig(data);
        writeSensorConfig.current = data;
    }

    async function writeData() {
        const data = await saveSensorConfig({ MetaData: Card, SensorId: sensorId, SensorConfig: writeSensorConfig.current });
        if (typeof data === "number") {
            console.log("Disconnect: ", data)
            navigate('/dashboard');
        }
        console.log("Settings saved")
    }

    useEffect(() => {
        fetchData()
    }, [])
   
    return (
        <Modal title="Sensor larm" onOk={handleSaveConfig} onCancel={handleCancel} okText="Spara" cancelText="Avbryt" open>
            <Form layout="vertical">
                <Flex justify="space-between" gap="middle" style={{ flexDirection: "column", paddingTop: "40px", paddingBottom: "40px" }}>
                    <div style={{ display: "table", marginTop:"40px" }}>
                        <div style={{ display: "table-cell", width: "76%" }}>{t('page.card-details.sensorconfig.activate')}:</div>
                        <div style={{ display: "table-cell" }}><Checkbox checked={sensorConfig.bActive} onChange={(e) => writeSensorConfig.current.bActive = e.target.checked} style={{ transform: "scale(2)" }} /> </div>
                    </div>
                    <div style={{ display: "table", marginTop: "40px" }}>
                        <div style={{ display: "table-cell", width: "80%" }}>{t('page.card-details.sensorconfig.upperthres')}:</div>
                        <div style={{ display: "table-cell" }}><InputNumber value={sensorConfig.MaxThreshold / 10.0} onChange={ (value) => writeSensorConfig.current.MaxThreshold = (value * 10) } min={-100.0} max={100.0} style={{}} /> </div>
                        <div style={{ display: "table-cell", paddingLeft: "10px" }}>{/*todo: Add sensor unit*/}</div>
                    </div>
                    <div style={{ display: "table", marginTop: "40px" }}>
                        <div style={{ display: "table-cell", width: "80%" }}>{t('page.card-details.sensorconfig.lowerthres')}:</div>
                        <div style={{ display: "table-cell" }}><InputNumber value={sensorConfig.MinThreshold / 10.0} onChange={(value) => writeSensorConfig.current.MinThreshold = (value * 10) } min={-100.0} max={100.0} style={{}} /> </div>
                        <div style={{ display: "table-cell", paddingLeft: "10px" }}></div>
                    </div>
                </Flex>
            </Form>
        </Modal>
    )
}
export default SensorModal
